import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { FC, PropsWithChildren, useState } from "react"
import { ONE_DAY_MILLISECONDS } from "~/utils"

const DEFAULT_GC_TIME = 7 * ONE_DAY_MILLISECONDS

const ReactQueryProvider: FC<PropsWithChildren> = ({ children }) => {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            retry: 1,
            gcTime: DEFAULT_GC_TIME,
            refetchOnWindowFocus: false,
          },
        },
      })
  )

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
}

export default ReactQueryProvider
